<template>
  <aside class="left-sidebar">
    <!-- Sidebar scroll-->
    <div>
      <div class="brand-logo d-flex align-items-center justify-content-between">
        <a href="/" class="text-nowrap fs-6 fw-bold mx-auto mt-1">
          <!-- logo otomatis dari backend / fallback -->
          <img :src="preview" alt="Logo Klinik" height="100">

          <!-- AZZAHRA
          <sup class="bg-success rounded-pill text-white fw-normal px-2">Admin</sup>-->
        </a>
        <div class="close-btn d-xl-none d-block sidebartoggler cursor-pointer" id="sidebarCollapse">
          <i class="ti ti-x fs-6"></i>
        </div>
      </div>
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav scroll-sidebar" data-simplebar>
        <ul id="sidebarnav">
          <li
            v-for="(menu, i) in filteredMenu"
            :key="i"
            :class="{
        'nav-small-cap': menu.type === 'label',
        'sidebar-item': menu.type !== 'label',
        selected: menu.open
      }"
          >
            <!-- Label -->
            <template v-if="menu.type === 'label'">
              <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
              <span class="hide-menu">{{ menu.label }}</span>
            </template>

            <!-- Divider -->
            <template v-else-if="menu.type === 'divider'">
              <span class="sidebar-divider lg"></span>
            </template>

            <!-- Single Link -->
            <template v-else-if="menu.type === 'single'">
              <router-link
                :to="menu.to"
                class="sidebar-link justify-content-between"
                active-class="active"
                exact
              >
                <div class="d-flex align-items-center gap-3">
                  <i :class="menu.icon"></i>
                  <span class="hide-menu">{{ menu.label }}</span>
                </div>
                <span
                  v-if="menu.badge"
                  class="hide-menu badge bg-secondary-subtle text-secondary fs-1 py-1"
                >{{ menu.badge }}</span>
              </router-link>
            </template>

            <!-- Menu with children -->
            <template v-else-if="menu.type === 'menu'">
              <a
                href="#"
                class="sidebar-link justify-content-between has-arrow"
                :class="{ active: menu.open }"
                @click.prevent="toggleMenu(i)"
                :aria-expanded="menu.open"
              >
                <div class="d-flex align-items-center gap-3">
                  <i :class="menu.icon"></i>
                  <span class="hide-menu">{{ menu.label }}</span>
                </div>
              </a>
              <ul
                class="collapse first-level"
                :class="{ in: menu.open }"
                :aria-expanded="menu.open"
              >
                <li v-for="(child, j) in menu.children" :key="j" class="sidebar-item">
                  <router-link
                    :to="{ path: child.to, query: child.query || {} }"
                    class="sidebar-link justify-content-between"
                    active-class="active"
                    exact
                  >
                    <div class="d-flex align-items-center gap-3">
                      <span
                        v-if="child.icon"
                        class="round-16 d-flex align-items-center justify-content-center"
                      >
                        <i :class="child.icon"></i>
                      </span>
                      <span class="hide-menu">{{ child.label }}</span>
                    </div>
                  </router-link>
                </li>
              </ul>
            </template>
          </li>
        </ul>

        <div
          class="p-3 hide-menu bg-light-secondary position-relative mt-5 rounded text-center mb-3 mb-xl-0 small"
        >
          <div class="small">
            &copy; Copyright 2025 - Azzahra
            <br>By
            <a
              href="https://uninet.net.id/"
              target="_blank"
              class="pe-1 text-primary text-decoration-underline"
            >UNINET</a> | All Right Reserved
          </div>
        </div>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../config'

export default {
	updated() {},
	mounted() {
		// buka otomatis sesuai route aktif
		this.menus.forEach((menu) => {
			if (menu.type === 'menu') {
				menu.open = menu.children.some((c) => this.isActive(c))
			}
		})
	},

	data() {
		return {
			logoUrl: require('@/assets/logo_dzikri.png'), // default lokal
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			menus: [
				{ type: 'label', label: 'BERANDA' },
				{ type: 'single', label: 'Dashboard', icon: 'ti ti-atom', to: '/' },
				{
					type: 'single',
					label: 'Daftar Pemeriksaan',
					icon: 'ti ti-clipboard-check',
					to: '/user-examination'
				},
				{ type: 'divider' },

				{ type: 'label', label: 'RESPONDEN' },
				{
					type: 'menu',
					label: 'Responden',
					icon: 'ti ti-news',
					open: false,
					children: [{ to: '/responden', label: 'Daftar Responden', icon: 'ti ti-circle' }, { to: '/form-responden', query: { type: 'responden' }, label: 'Tambah Responden', icon: 'ti ti-circle' }]
				},
				{
					type: 'single',
					label: 'Assessment',
					icon: 'ti ti-list-check',
					to: '/user-assessment',
					badge: 'New'
				},
				{ type: 'divider' },

				{ type: 'label', label: 'APLIKASI' },
				{
					type: 'menu',
					label: 'Artikel',
					icon: 'ti ti-news',
					open: false,
					children: [{ to: '/post', label: 'Daftar Artikel', icon: 'ti ti-circle' }, { to: '/form-post', label: 'Tambah Artikel', icon: 'ti ti-circle' }]
				},
				{
					type: 'single',
					label: 'Pesan',
					icon: 'ti ti-message-dots',
					to: '/message',
					badge: 'New'
				},
				{
					type: 'single',
					label: 'Penjadwalan',
					icon: 'ti ti-calendar-event',
					to: '/user-schedules',
					badge: 'New'
				},
				{ type: 'single', label: 'Laporan', icon: 'ti ti-report-analytics', to: '/report' },
				{ type: 'divider' },

				{ type: 'label', label: 'PENGATURAN' },
				{ type: 'single', roles: ['admin'], label: 'Umum', icon: 'ti ti-settings', to: '/config-general' },
				{ type: 'single', label: 'Akunku', icon: 'ti ti-user-circle', to: '/my-account' },
				{
					type: 'menu',
					label: 'User Admin',
					icon: 'ti ti-user-shield',
					open: false,
					roles: ['admin'],
					children: [{ to: '/user', label: 'Daftar User', icon: 'ti ti-circle' }, { to: '/form-user', query: { type: 'admin' }, label: 'Tambah User', icon: 'ti ti-circle' }]
				},
				{ type: 'single', roles: ['admin'], label: 'Lokasi Klinik', icon: 'ti ti-map-pin-2', to: '/location' },
				{ type: 'divider' },

				{ type: 'label', roles: ['admin'], label: 'DATABASE' },
				{
					type: 'menu',
					label: 'Data Master',
					icon: 'ti ti-layout-grid',
					open: false,
					roles: ['admin'],
					children: [{ to: '/assessment', label: 'Medical Assessment', icon: 'ti ti-circle' }, { to: '/exam', label: 'Medical Examination', icon: 'ti ti-circle' }]
				},
				{ type: 'divider' },

				{ type: 'label', label: 'BANTUAN' },
				{ type: 'single', label: 'Pengguna', icon: 'ti ti-book', to: '/docs-user' },
				{ type: 'single', label: 'FAQ', icon: 'ti ti-help', to: '/docs-faq' },
				{ type: 'divider' }
			]
			// userRoles: ['doctor']
		}
	},
	computed: {
		// ...mapGetters(['userRoles']),
		...mapGetters({
			conf: 'location/getConfig'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.conf && this.conf.logo) {
					// if (this.dataUser.user_profile.attachment === null || this.dataUser.user_profile.attachment === 'null' || this.dataUser.user_profile.attachment === undefined || this.dataUser.user_profile.attachment === 'undefined' || this.dataUser.user_profile.attachment === '') {
					// } else {
						url = config("api.baseUrl") + 'storage/uploads/' + this.conf.logo
					// }
				} else {
					url = this.logoUrl
				}
				return url
			},
			set(value) {
				this.conf.logo = value
			}
		},
		userRoles() {
			return this.user_login.type.split(',')
		},
		filteredMenu() {
			return this.menus.filter((item) => {
				if (!item.roles) return true // menu tanpa role → semua bisa lihat
				return item.roles.some((r) => this.userRoles.includes(r))
			})
		}
	},
	watch: {
		$route(to) {
			this.menus.forEach((menu) => {
				if (menu.type === 'menu') {
					menu.open = menu.children.some((c) => this.isActive(c))
				}
			})
		}
	},
	methods: {
		isActive(child) {
			// cek exact path + query
			const samePath = this.$route.path === child.to
			const sameQuery = JSON.stringify(this.$route.query || {}) === JSON.stringify(child.query || {})
			return samePath && sameQuery
		},
		toggleMenu(index) {
			this.menus.forEach((m, i) => {
				if (m.type === 'menu' && i !== index) m.open = false
			})
			if (this.menus[index].type === 'menu') {
				this.menus[index].open = !this.menus[index].open
			}
		}
	}
}
</script>

<style scoped>
/* contoh styling biar collapse jalan */
.collapse {
	display: none;
}
.collapse.in {
	display: block;
}
.sidebar-link.active {
	font-weight: bold;
	color: blue;
}
</style>